var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59766 25.1133H18.7734C19.2891 25.1133 19.7109 24.7031 19.7109 24.1758C19.7109 23.7656 19.4297 23.4023 19.0547 23.2734C17.5781 22.6875 17.2734 20.7773 18.7266 19.3125C19.1719 18.8672 19.7109 18.293 19.7109 17.1211V3.67969C19.7109 1.24219 18.5039 0 16.0781 0H3.63281C1.20703 0 0 1.23047 0 3.67969V21.4922C0 23.9062 1.21875 25.1133 3.59766 25.1133ZM3.70312 23.2266C2.51953 23.2266 1.88672 22.5938 1.88672 21.4805C1.88672 20.4258 2.63672 19.7461 3.80859 19.7461H15.832C15.9844 19.7461 16.125 19.7344 16.2422 19.7109C15.6914 20.9297 15.7852 22.2188 16.4062 23.2266H3.70312ZM3.35156 17.9648C2.98828 17.9648 2.68359 17.6602 2.68359 17.2852V2.48438C2.68359 2.10938 2.98828 1.81641 3.35156 1.81641C3.71484 1.81641 4.03125 2.10938 4.03125 2.48438V17.2852C4.03125 17.6602 3.71484 17.9648 3.35156 17.9648Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookClosed);
export default __webpack_public_path__ + "static/media/book-closed.45fdc42eaa0f759f7552bd75935cf5d3.svg";
export { ForwardRef as ReactComponent };